module.exports = __webpack_public_path__ + "media/images/tour/m/zh-hant-b32feb7389e6623fba135513290116b5.png";